import { Component, Inject, LOCALE_ID, OnInit } from '@angular/core';

@Component({
  selector: 'carm-home-page',
  templateUrl: './home-page.component.html',
  styleUrls: ['./home-page.component.scss'],
})
export class HomePageComponent implements OnInit {

  locale:string;
  constructor(@Inject(LOCALE_ID) protected localeId: string) {
  }

  ngOnInit() {
    this.locale = this.localeId;
  }
}
